/* eslint-disable */
/**
 * THIS FILE IS AUTOGENERATED, DO NOT EDIT IT!
 * Instead, edit one of the .graphql files in this project and run
 *
 * npm run generate:front-dashboard:back-dashboard-api:entities
 */

import { backDashboardApi } from './base-api';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = {
  [K in keyof T]: T[K];
};
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & {
  [SubKey in K]?: Maybe<T[SubKey]>;
};
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & {
  [SubKey in K]: Maybe<T[SubKey]>;
};
export type MakeEmpty<
  T extends { [key: string]: unknown },
  K extends keyof T
> = { [_ in K]?: never };
export type Incremental<T> =
  | T
  | {
      [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never;
    };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string };
  String: { input: string; output: string };
  Boolean: { input: boolean; output: boolean };
  Int: { input: number; output: number };
  Float: { input: number; output: number };
  /** The `JSONObject` scalar type represents JSON objects as specified by [ECMA-404](http://www.ecma-international.org/publications/files/ECMA-ST/ECMA-404.pdf). */
  JSONObject: { input: any; output: any };
};

export type ActivityLogEntries = {
  __typename?: 'ActivityLogEntries';
  nodes: Array<ActivityLogEntry>;
  pageInfo: PageInfo;
  totalCount: Scalars['Float']['output'];
};

export type ActivityLogEntry = {
  __typename?: 'ActivityLogEntry';
  _id: Scalars['String']['output'];
  event: Scalars['JSONObject']['output'];
  location?: Maybe<LocationRef>;
  metadata_created?: Maybe<Scalars['Float']['output']>;
  metadata_deleted?: Maybe<Scalars['Float']['output']>;
  metadata_updated?: Maybe<Scalars['Float']['output']>;
  targetEntity: ActivityLogEntryTargetEntity;
  timestamp: Scalars['Float']['output'];
  user: UserRef;
};

export type ActivityLogEntryTargetEntity = {
  __typename?: 'ActivityLogEntryTargetEntity';
  ref: EntityRefUnion;
  type: ActivityLogEntryType;
};

export enum ActivityLogEntryType {
  Invitation = 'Invitation',
  Item = 'Item',
  Location = 'Location',
  Order = 'Order',
  UserGroup = 'UserGroup',
}

export enum ActivityLogScope {
  Item = 'Item',
  Location = 'Location',
  Order = 'Order',
  User = 'User',
}

export type ActivityLogScopeInput = {
  scope: ActivityLogScope;
  value: Scalars['String']['input'];
};

export type AppConfig = {
  __typename?: 'AppConfig';
  contactEmail?: Maybe<Scalars['String']['output']>;
  maintenanceStatus: MaintenanceStatus;
};

/** Represents an Atkomst client. */
export type AtkomstClient = {
  __typename?: 'AtkomstClient';
  country: Scalars['String']['output'];
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
};

export type BookingsSettings = {
  __typename?: 'BookingsSettings';
  acceptTermsText?: Maybe<Scalars['String']['output']>;
  allowOutOfStockOrders?: Maybe<Scalars['Boolean']['output']>;
  usersCanSetCollectedState?: Maybe<Scalars['Boolean']['output']>;
};

export type BookingsSettingsInput = {
  acceptTermsText: Scalars['String']['input'];
  allowOutOfStockOrders: Scalars['Boolean']['input'];
  usersCanSetCollectedState: Scalars['Boolean']['input'];
};

export type BulkUpdateStockInput = {
  locationId: Scalars['String']['input'];
  stock: Array<StockArgs>;
};

export enum CacheControlScope {
  Private = 'PRIVATE',
  Public = 'PUBLIC',
}

/** Represents a CDS location. */
export type CdsLocation = {
  __typename?: 'CdsLocation';
  country: Scalars['String']['output'];
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
};

export type CdsLocationEntry = {
  __typename?: 'CdsLocationEntry';
  name: Scalars['String']['output'];
  primary: Scalars['Boolean']['output'];
};

export enum CombinationColor {
  Black = 'Black',
  Blue = 'Blue',
  Green = 'Green',
  Grey = 'Grey',
  Multicolor = 'Multicolor',
  Orange = 'Orange',
  Red = 'Red',
  Striped = 'Striped',
  Unknown = 'Unknown',
  White = 'White',
  Yellow = 'Yellow',
}

export type Combinations = {
  __typename?: 'Combinations';
  /** The item's color */
  color?: Maybe<CombinationColor>;
  /** The item's fit when it is a garment */
  fit?: Maybe<Scalars['String']['output']>;
  /** The item's size when it is a garment */
  size?: Maybe<Scalars['String']['output']>;
};

export type CombinationsInput = {
  color?: InputMaybe<CombinationColor>;
  fit?: InputMaybe<Scalars['String']['input']>;
  size?: InputMaybe<Scalars['String']['input']>;
};

export type CommentOrderInput = {
  comment: Scalars['String']['input'];
  itemId?: InputMaybe<Scalars['String']['input']>;
  orderId: Scalars['String']['input'];
  user: UserInput;
};

export type CommunicationSettings = {
  __typename?: 'CommunicationSettings';
  adminInbox?: Maybe<Scalars['String']['output']>;
  language: Scalars['String']['output'];
};

export type CommunicationSettingsInput = {
  adminInbox: Scalars['String']['input'];
  language: Scalars['String']['input'];
};

export type CreateImageUploadUrlInput = {
  fileName: Scalars['String']['input'];
  locationSlug?: InputMaybe<Scalars['String']['input']>;
  mimeType: Scalars['String']['input'];
  tag: Scalars['String']['input'];
};

export type CreateInvitationInput = {
  email: Scalars['String']['input'];
  name: Scalars['String']['input'];
};

export type CreateLocalItemsInput = {
  category: Scalars['Int']['input'];
  combinations: CombinationsInput;
  description: Scalars['String']['input'];
  imageUrls: Array<Scalars['String']['input']>;
  price?: InputMaybe<PriceInput>;
  productName: Scalars['String']['input'];
  properties: PropertiesInput;
  type: ItemType;
};

export type CreateLocationInput = {
  atkomstClientId: Scalars['String']['input'];
  cdsLocation: Array<Scalars['String']['input']>;
  country: Scalars['String']['input'];
  enabled: Scalars['Boolean']['input'];
  mainLanguage: Scalars['String']['input'];
  name: Scalars['String']['input'];
};

export type CreateOrderInput = {
  comment?: InputMaybe<Scalars['String']['input']>;
  invitationId?: InputMaybe<Scalars['String']['input']>;
  itemIds: Array<Scalars['String']['input']>;
  requestedBy: OrderUserInput;
  requestedFor: UserInput;
  type: OrderType;
};

export type Document = {
  __typename?: 'Document';
  name: Scalars['String']['output'];
  url: Scalars['String']['output'];
};

export type EntityRefUnion =
  | InvitationRef
  | ItemRefWithImage
  | LocationRef
  | OrderRef
  | UserGroupRef;

export type HelpCenterSettings = {
  __typename?: 'HelpCenterSettings';
  contactEmail?: Maybe<Scalars['String']['output']>;
};

export type HelpCenterSettingsInput = {
  contactEmail: Scalars['String']['input'];
};

export type ImageUploadUrl = {
  __typename?: 'ImageUploadUrl';
  /** Public URL the uploaded image will be reachable at */
  publicUrl: Scalars['String']['output'];
  /** Signed URL the client must PUT the file bytes to */
  uploadUrl: Scalars['String']['output'];
};

/** User object */
export type InventoryEntry = {
  __typename?: 'InventoryEntry';
  _orderItemId: Scalars['String']['output'];
  item: Item;
  lastStatus: ItemStatus;
  metadata_created?: Maybe<Scalars['Float']['output']>;
  metadata_deleted?: Maybe<Scalars['Float']['output']>;
  metadata_updated?: Maybe<Scalars['Float']['output']>;
  order: OrderRef;
  statusHistory: Array<StatusHistory>;
};

export enum InventoryScope {
  Me = 'Me',
  User = 'User',
}

export type InventoryScopeInput = {
  scope: InventoryScope;
  value: Scalars['String']['input'];
};

export type Invitation = {
  __typename?: 'Invitation';
  _id: Scalars['String']['output'];
  _orderId?: Maybe<Scalars['String']['output']>;
  email: Scalars['String']['output'];
  expiresAt: Scalars['Float']['output'];
  location: LocationRef;
  metadata_created?: Maybe<Scalars['Float']['output']>;
  metadata_deleted?: Maybe<Scalars['Float']['output']>;
  metadata_updated?: Maybe<Scalars['Float']['output']>;
  name: Scalars['String']['output'];
  order?: Maybe<InvitationOrderRef>;
};

export type InvitationOrderRef = {
  __typename?: 'InvitationOrderRef';
  _id: Scalars['String']['output'];
  requestedFor: UserRef;
  slug: Scalars['String']['output'];
};

export type InvitationRef = {
  __typename?: 'InvitationRef';
  _id: Scalars['String']['output'];
};

export type Invitations = {
  __typename?: 'Invitations';
  nodes: Array<Invitation>;
  pageInfo: PageInfo;
  totalCount: Scalars['Float']['output'];
};

export type Item = {
  __typename?: 'Item';
  /** ID of the related "Location" entity */
  _id: Scalars['String']['output'];
  categories: Array<Scalars['String']['output']>;
  category: Scalars['Float']['output'];
  combinations: Combinations;
  description: Scalars['String']['output'];
  displayName: Scalars['String']['output'];
  documents: Array<Document>;
  imageUrls: Array<Scalars['String']['output']>;
  location?: Maybe<LocationRef>;
  metadata_created?: Maybe<Scalars['Float']['output']>;
  metadata_deleted?: Maybe<Scalars['Float']['output']>;
  metadata_updated?: Maybe<Scalars['Float']['output']>;
  price?: Maybe<Price>;
  productName: Scalars['String']['output'];
  properties: Properties;
  sku: Scalars['String']['output'];
  slug: Scalars['String']['output'];
  source: ItemSource;
  type: ItemType;
};

export type ItemCounts = {
  __typename?: 'ItemCounts';
  approved: Scalars['Int']['output'];
  cancelled: Scalars['Int']['output'];
  collected: Scalars['Int']['output'];
  discarded: Scalars['Int']['output'];
  pending: Scalars['Int']['output'];
  prepared: Scalars['Int']['output'];
  recalled: Scalars['Int']['output'];
  refurbish: Scalars['Int']['output'];
  rejected: Scalars['Int']['output'];
  returned: Scalars['Int']['output'];
};

export enum ItemOrigin {
  Checka = 'Checka',
  CheckaOld = 'CheckaOld',
  IkeaEquipment = 'IkeaEquipment',
}

export type ItemRef = {
  __typename?: 'ItemRef';
  /** ID of the related "Location" entity */
  _id: Scalars['String']['output'];
  displayName: Scalars['String']['output'];
  productName: Scalars['String']['output'];
  type: ItemType;
};

export type ItemRefWithImage = {
  __typename?: 'ItemRefWithImage';
  /** ID of the related "Location" entity */
  _id: Scalars['String']['output'];
  displayName: Scalars['String']['output'];
  imageUrl: Scalars['String']['output'];
  productName: Scalars['String']['output'];
  type: ItemType;
};

export type ItemSource = {
  __typename?: 'ItemSource';
  origin: ItemOrigin;
  url?: Maybe<Scalars['String']['output']>;
};

export enum ItemStatus {
  Approved = 'Approved',
  Cancelled = 'Cancelled',
  Collected = 'Collected',
  Discarded = 'Discarded',
  Pending = 'Pending',
  Prepared = 'Prepared',
  Recalled = 'Recalled',
  Refurbish = 'Refurbish',
  Rejected = 'Rejected',
  Returned = 'Returned',
}

export enum ItemType {
  Clothing = 'Clothing',
  Equipment = 'Equipment',
}

export type Items = {
  __typename?: 'Items';
  nodes: Array<Item>;
  pageInfo: PageInfo;
  totalCount: Scalars['Float']['output'];
};

/** Represents a location with its details and stock items. */
export type Location = {
  __typename?: 'Location';
  /** ID of the related "Location" entity */
  _id: Scalars['String']['output'];
  atkomstClientId: Scalars['String']['output'];
  cdsLocation?: Maybe<Array<CdsLocationEntry>>;
  country: Scalars['String']['output'];
  enabled: Scalars['Boolean']['output'];
  mainLanguage: Scalars['String']['output'];
  metadata_created?: Maybe<Scalars['Float']['output']>;
  metadata_deleted?: Maybe<Scalars['Float']['output']>;
  metadata_updated?: Maybe<Scalars['Float']['output']>;
  name: Scalars['String']['output'];
  settings: LocationSettings;
  slug: Scalars['String']['output'];
  stock: Array<StockItem>;
  warehouses: Array<Warehouse>;
};

/** Reference to a location with minimal details. */
export type LocationRef = {
  __typename?: 'LocationRef';
  /** ID of the related "Location" entity */
  _id: Scalars['String']['output'];
  atkomstClientId: Scalars['String']['output'];
  cdsLocation?: Maybe<Array<CdsLocationEntry>>;
  country: Scalars['String']['output'];
  name: Scalars['String']['output'];
};

export type LocationSettings = {
  __typename?: 'LocationSettings';
  bookings: BookingsSettings;
  communication: CommunicationSettings;
  helpCenter: HelpCenterSettings;
  metadata_created?: Maybe<Scalars['Float']['output']>;
  metadata_deleted?: Maybe<Scalars['Float']['output']>;
  metadata_updated?: Maybe<Scalars['Float']['output']>;
};

export type Locations = {
  __typename?: 'Locations';
  nodes: Array<Location>;
  pageInfo?: Maybe<PageInfo>;
  totalCount: Scalars['Float']['output'];
};

export type MaintenanceStatus = {
  __typename?: 'MaintenanceStatus';
  dismissable?: Maybe<Scalars['Boolean']['output']>;
  emergency?: Maybe<Scalars['Boolean']['output']>;
  enabled: Scalars['Boolean']['output'];
  forceViewerMode?: Maybe<Scalars['Boolean']['output']>;
  text?: Maybe<Scalars['String']['output']>;
};

export type Mutation = {
  __typename?: 'Mutation';
  addExternalCoworker: MutationResponse;
  bulkCreateLocalItems: MutationResponse;
  bulkDeleteLocalItems: MutationResponse;
  bulkDisableStockItem: MutationResponse;
  bulkEnableStockItem: MutationResponse;
  bulkRecallItems: MutationResponse;
  bulkRemoveStockItem: MutationResponse;
  bulkUpdateItemStatus: MutationResponse;
  bulkUpdateLocalItems: MutationResponse;
  bulkUpdateOrderOnHold: MutationResponse;
  bulkUpdateStock: MutationResponse;
  commentOrder: MutationResponse;
  createImageUploadUrl: ImageUploadUrl;
  createInvitation: MutationResponse;
  createLocation: Location;
  createOrder: MutationResponse;
  createWarehouse: MutationResponse;
  deleteWarehouse: MutationResponse;
  recallUserItems: MutationResponse;
  removeExternalCoworker: MutationResponse;
  sendMessage: Scalars['Boolean']['output'];
  updateInvitationOwnership: MutationResponse;
  updateLocation: MutationResponse;
  updateSettings: MutationResponse;
  updateUserRoles: MutationResponse;
  updateWarehouse: MutationResponse;
};

export type MutationAddExternalCoworkerArgs = {
  email: Scalars['String']['input'];
  locationId: Scalars['String']['input'];
};

export type MutationBulkCreateLocalItemsArgs = {
  items: Array<CreateLocalItemsInput>;
  locationId: Scalars['String']['input'];
};

export type MutationBulkDeleteLocalItemsArgs = {
  itemIds: Array<Scalars['String']['input']>;
  locationId: Scalars['String']['input'];
};

export type MutationBulkDisableStockItemArgs = {
  itemIds: Array<Scalars['String']['input']>;
  locationId: Scalars['String']['input'];
};

export type MutationBulkEnableStockItemArgs = {
  itemIds: Array<Scalars['String']['input']>;
  locationId: Scalars['String']['input'];
};

export type MutationBulkRecallItemsArgs = {
  itemIds: Array<Scalars['String']['input']>;
  locationId: Scalars['String']['input'];
};

export type MutationBulkRemoveStockItemArgs = {
  itemIds: Array<Scalars['String']['input']>;
  locationId: Scalars['String']['input'];
  warehouseId: Scalars['String']['input'];
};

export type MutationBulkUpdateItemStatusArgs = {
  bulkUpdateItemStatusInput: Array<UpdateItemstatusInput>;
};

export type MutationBulkUpdateLocalItemsArgs = {
  locationId: Scalars['String']['input'];
  product: Array<UpdateLocalItemInput>;
};

export type MutationBulkUpdateOrderOnHoldArgs = {
  locationId: Scalars['String']['input'];
  onHold: Scalars['Boolean']['input'];
  orderIds: Array<Scalars['String']['input']>;
};

export type MutationBulkUpdateStockArgs = {
  input: BulkUpdateStockInput;
};

export type MutationCommentOrderArgs = {
  commentOrderInput: CommentOrderInput;
};

export type MutationCreateImageUploadUrlArgs = {
  input: CreateImageUploadUrlInput;
};

export type MutationCreateInvitationArgs = {
  invitation: CreateInvitationInput;
  locationId: Scalars['String']['input'];
};

export type MutationCreateLocationArgs = {
  input: CreateLocationInput;
};

export type MutationCreateOrderArgs = {
  createOrderInput: CreateOrderInput;
  locationId: Scalars['String']['input'];
};

export type MutationCreateWarehouseArgs = {
  locationId: Scalars['String']['input'];
  warehouse: WarehouseArgs;
};

export type MutationDeleteWarehouseArgs = {
  locationId: Scalars['String']['input'];
  warehouseId: Scalars['String']['input'];
};

export type MutationRecallUserItemsArgs = {
  locationId: Scalars['String']['input'];
  userEmail: Scalars['String']['input'];
};

export type MutationRemoveExternalCoworkerArgs = {
  email: Scalars['String']['input'];
  locationId: Scalars['String']['input'];
};

export type MutationSendMessageArgs = {
  sendMessageInput: SendMessageInput;
};

export type MutationUpdateInvitationOwnershipArgs = {
  invitationId: Scalars['String']['input'];
  locationId: Scalars['String']['input'];
  user: UserInput;
};

export type MutationUpdateLocationArgs = {
  input: UpdateLocationInput;
  locationId: Scalars['String']['input'];
};

export type MutationUpdateSettingsArgs = {
  locationId: Scalars['String']['input'];
  settings: UpdateLocationSettingsInput;
};

export type MutationUpdateUserRolesArgs = {
  email: Scalars['String']['input'];
  locationId: Scalars['String']['input'];
  roles: UserRolesInput;
};

export type MutationUpdateWarehouseArgs = {
  locationId: Scalars['String']['input'];
  warehouse: WarehouseArgs;
  warehouseId: Scalars['String']['input'];
};

export type MutationResponse = {
  __typename?: 'MutationResponse';
  _id?: Maybe<Array<Scalars['String']['output']>>;
  result: Scalars['Boolean']['output'];
};

export type Order = {
  __typename?: 'Order';
  _id: Scalars['String']['output'];
  _invitationId?: Maybe<Scalars['String']['output']>;
  comments: Array<OrderComment>;
  items: Array<OrderItem>;
  location: LocationRef;
  metadata_created?: Maybe<Scalars['Float']['output']>;
  metadata_deleted?: Maybe<Scalars['Float']['output']>;
  metadata_updated?: Maybe<Scalars['Float']['output']>;
  onHold?: Maybe<Scalars['Boolean']['output']>;
  requestedBy: UserRef;
  requestedFor: UserRef;
  slug: Scalars['String']['output'];
  status: OrderStatus;
  type: OrderType;
};

export type OrderComment = {
  __typename?: 'OrderComment';
  _orderItemId?: Maybe<Scalars['String']['output']>;
  message: Scalars['String']['output'];
  metadata_created?: Maybe<Scalars['Float']['output']>;
  user: UserRef;
};

export type OrderCounts = {
  __typename?: 'OrderCounts';
  completed: Scalars['Int']['output'];
  pending: Scalars['Int']['output'];
};

export type OrderItem = {
  __typename?: 'OrderItem';
  _orderItemId: Scalars['String']['output'];
  item: Item;
  lastStatus: ItemStatus;
  metadata_created?: Maybe<Scalars['Float']['output']>;
  metadata_deleted?: Maybe<Scalars['Float']['output']>;
  metadata_updated?: Maybe<Scalars['Float']['output']>;
  statusHistory: Array<StatusHistory>;
};

export type OrderRef = {
  __typename?: 'OrderRef';
  _id: Scalars['String']['output'];
  slug: Scalars['String']['output'];
  type: OrderType;
};

export enum OrderScope {
  Coworkers = 'Coworkers',
  Location = 'Location',
  Me = 'Me',
  User = 'User',
}

export type OrderScopeInput = {
  scope: OrderScope;
  value: Scalars['String']['input'];
};

export enum OrderStatus {
  Completed = 'Completed',
  Pending = 'Pending',
}

export enum OrderType {
  Inventory = 'Inventory',
  Order = 'Order',
}

export type OrderUserInput = {
  acceptedTerms: Scalars['Boolean']['input'];
  companyName?: InputMaybe<Scalars['String']['input']>;
  displayName: Scalars['String']['input'];
  email: Scalars['String']['input'];
  jobTitle?: InputMaybe<Scalars['String']['input']>;
  manager?: InputMaybe<Scalars['String']['input']>;
  networkId?: InputMaybe<Scalars['String']['input']>;
  officeLocation?: InputMaybe<Scalars['String']['input']>;
};

export type Orders = {
  __typename?: 'Orders';
  nodes: Array<Order>;
  pageInfo?: Maybe<PageInfo>;
  totalCount: Scalars['Float']['output'];
};

/** Pagination related fields */
export type PageInfo = {
  __typename?: 'PageInfo';
  endCursor?: Maybe<Scalars['String']['output']>;
  hasNextPage: Scalars['Boolean']['output'];
};

export type PaginationInput = {
  after?: InputMaybe<Scalars['String']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
};

export type Price = {
  __typename?: 'Price';
  amount: Scalars['Float']['output'];
  currency: Scalars['String']['output'];
};

export type PriceInput = {
  amount: Scalars['Float']['input'];
  currency: Scalars['String']['input'];
};

export type Properties = {
  __typename?: 'Properties';
  /** The item's depth when it is an equipment */
  depth?: Maybe<Scalars['Float']['output']>;
  /** The item's height when it is an equipment */
  height?: Maybe<Scalars['Float']['output']>;
  /** The item's fabric when it is a garment */
  material?: Maybe<Scalars['String']['output']>;
  /** The item's weight when it is an equipment */
  weight?: Maybe<Scalars['Float']['output']>;
  /** The item's width when it is an equipment */
  width?: Maybe<Scalars['Float']['output']>;
};

export type PropertiesInput = {
  depth?: InputMaybe<Scalars['Float']['input']>;
  height?: InputMaybe<Scalars['Float']['input']>;
  material?: InputMaybe<Scalars['String']['input']>;
  weight?: InputMaybe<Scalars['Float']['input']>;
  width?: InputMaybe<Scalars['Float']['input']>;
};

export type Query = {
  __typename?: 'Query';
  activityLogs: ActivityLogEntries;
  administrators: Users;
  appConfig: AppConfig;
  atkomstClients: Array<AtkomstClient>;
  cdsLocations: Array<CdsLocation>;
  externalUsers: Users;
  inventory: UserInventory;
  invitation?: Maybe<Invitation>;
  invitations: Invitations;
  item?: Maybe<Item>;
  items: Items;
  location?: Maybe<Location>;
  locations: Locations;
  order?: Maybe<Order>;
  orders: Orders;
  roles: RolesResult;
  superadminLocations: Locations;
  user?: Maybe<User>;
  users: Users;
};

export type QueryActivityLogsArgs = {
  locationId: Scalars['String']['input'];
  pagination?: InputMaybe<PaginationInput>;
  scope: ActivityLogScopeInput;
};

export type QueryAdministratorsArgs = {
  locationId: Scalars['String']['input'];
  pagination?: InputMaybe<PaginationInput>;
};

export type QueryAtkomstClientsArgs = {
  country: Scalars['String']['input'];
};

export type QueryExternalUsersArgs = {
  locationId: Scalars['String']['input'];
  pagination?: InputMaybe<PaginationInput>;
};

export type QueryInventoryArgs = {
  locationId: Scalars['String']['input'];
  pagination?: InputMaybe<PaginationInput>;
  scope: InventoryScopeInput;
};

export type QueryInvitationArgs = {
  invitationId: Scalars['String']['input'];
};

export type QueryInvitationsArgs = {
  locationId: Scalars['String']['input'];
  pagination?: InputMaybe<PaginationInput>;
};

export type QueryItemArgs = {
  itemId: Scalars['String']['input'];
};

export type QueryItemsArgs = {
  locationId: Scalars['String']['input'];
  pagination?: InputMaybe<PaginationInput>;
};

export type QueryLocationArgs = {
  locationId: Scalars['String']['input'];
};

export type QueryLocationsArgs = {
  pagination?: InputMaybe<PaginationInput>;
};

export type QueryOrderArgs = {
  orderId: Scalars['String']['input'];
};

export type QueryOrdersArgs = {
  locationId?: InputMaybe<Scalars['String']['input']>;
  pagination?: InputMaybe<PaginationInput>;
  scope: OrderScopeInput;
};

export type QueryRolesArgs = {
  clientId?: InputMaybe<Scalars['String']['input']>;
};

export type QuerySuperadminLocationsArgs = {
  pagination?: InputMaybe<PaginationInput>;
};

export type QueryUserArgs = {
  email: Scalars['String']['input'];
  locationId: Scalars['String']['input'];
};

export type QueryUsersArgs = {
  locationId: Scalars['String']['input'];
  pagination?: InputMaybe<PaginationInput>;
};

export type RolePermission = {
  __typename?: 'RolePermission';
  name: Scalars['String']['output'];
};

export type RolesResult = {
  __typename?: 'RolesResult';
  accessToken: Scalars['String']['output'];
  roles: Array<UserRoleResult>;
};

export type SendMessageInput = {
  email: Scalars['String']['input'];
  message: Scalars['String']['input'];
};

export type StatusHistory = {
  __typename?: 'StatusHistory';
  _warehouseId?: Maybe<Scalars['String']['output']>;
  metadata_created?: Maybe<Scalars['Float']['output']>;
  reason?: Maybe<Scalars['String']['output']>;
  returnedToStock?: Maybe<Scalars['Boolean']['output']>;
  status: ItemStatus;
  user: UserRef;
};

export type StatusInput = {
  backToStock?: InputMaybe<Scalars['Boolean']['input']>;
  reason?: InputMaybe<Scalars['String']['input']>;
  status: ItemStatus;
  user: UserInput;
  warehouseId?: InputMaybe<Scalars['String']['input']>;
};

export type StockArgs = {
  amount?: InputMaybe<Scalars['Int']['input']>;
  itemId: Scalars['String']['input'];
  threshold?: InputMaybe<Scalars['Int']['input']>;
  warehouseId: Scalars['String']['input'];
};

export type StockItem = {
  __typename?: 'StockItem';
  availability: Array<StockItemAvailability>;
  discarded: Scalars['Float']['output'];
  item: ItemRef;
  lendOut: Scalars['Float']['output'];
  metadata_created?: Maybe<Scalars['Float']['output']>;
  metadata_deleted?: Maybe<Scalars['Float']['output']>;
  metadata_updated?: Maybe<Scalars['Float']['output']>;
  refurbish: Scalars['Float']['output'];
  reserved: Scalars['Float']['output'];
};

export type StockItemAvailability = {
  __typename?: 'StockItemAvailability';
  _warehouseId: Scalars['String']['output'];
  amount: Scalars['Float']['output'];
  metadata_created?: Maybe<Scalars['Float']['output']>;
  metadata_deleted?: Maybe<Scalars['Float']['output']>;
  metadata_updated?: Maybe<Scalars['Float']['output']>;
  threshold: Scalars['Float']['output'];
};

export type UpdateItemstatusInput = {
  comments: Scalars['String']['input'];
  orderId: Scalars['String']['input'];
  orderItemId: Scalars['String']['input'];
  status: StatusInput;
};

export type UpdateLocalItemInput = {
  _id: Scalars['String']['input'];
  category?: InputMaybe<Scalars['Float']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  imageUrls?: InputMaybe<Array<Scalars['String']['input']>>;
  price?: InputMaybe<PriceInput>;
  properties?: InputMaybe<PropertiesInput>;
};

export type UpdateLocationInput = {
  atkomstClientId?: InputMaybe<Scalars['String']['input']>;
  cdsLocation?: InputMaybe<Array<Scalars['String']['input']>>;
  country?: InputMaybe<Scalars['String']['input']>;
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
  mainLanguage?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateLocationSettingsInput = {
  bookings: BookingsSettingsInput;
  communication: CommunicationSettingsInput;
  helpCenter: HelpCenterSettingsInput;
};

/** User object */
export type User = {
  __typename?: 'User';
  displayName: Scalars['String']['output'];
  email: Scalars['String']['output'];
  items: ItemCounts;
  manager?: Maybe<Scalars['String']['output']>;
  orders: OrderCounts;
  roles?: Maybe<Array<Scalars['String']['output']>>;
};

/** Reference to a user group with minimal details. */
export type UserGroupRef = {
  __typename?: 'UserGroupRef';
  _id: Scalars['String']['output'];
  name: Scalars['String']['output'];
};

export type UserInput = {
  displayName: Scalars['String']['input'];
  email: Scalars['String']['input'];
  jobTitle?: InputMaybe<Scalars['String']['input']>;
  manager?: InputMaybe<Scalars['String']['input']>;
  networkId?: InputMaybe<Scalars['String']['input']>;
  officeLocation?: InputMaybe<Scalars['String']['input']>;
};

export type UserInventory = {
  __typename?: 'UserInventory';
  nodes: Array<InventoryEntry>;
  pageInfo?: Maybe<PageInfo>;
  totalCount: Scalars['Float']['output'];
};

/** Reference to a user with minimal details. */
export type UserRef = {
  __typename?: 'UserRef';
  displayName: Scalars['String']['output'];
  email: Scalars['String']['output'];
  jobTitle?: Maybe<Scalars['String']['output']>;
  manager?: Maybe<Scalars['String']['output']>;
  networkId?: Maybe<Scalars['String']['output']>;
  officeLocation?: Maybe<Scalars['String']['output']>;
};

export type UserRoleResult = {
  __typename?: 'UserRoleResult';
  clientReference: Scalars['String']['output'];
  description: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  permissions: Array<RolePermission>;
  service: Scalars['String']['output'];
};

export type UserRolesInput = {
  isLocationAdmin?: InputMaybe<Scalars['Boolean']['input']>;
  isOrderAdmin?: InputMaybe<Scalars['Boolean']['input']>;
  isStockAdmin?: InputMaybe<Scalars['Boolean']['input']>;
  isUserAdmin?: InputMaybe<Scalars['Boolean']['input']>;
};

export type Users = {
  __typename?: 'Users';
  nodes: Array<User>;
  pageInfo?: Maybe<PageInfo>;
  totalCount: Scalars['Float']['output'];
};

export type Warehouse = {
  __typename?: 'Warehouse';
  _id: Scalars['String']['output'];
  metadata_created?: Maybe<Scalars['Float']['output']>;
  metadata_deleted?: Maybe<Scalars['Float']['output']>;
  metadata_updated?: Maybe<Scalars['Float']['output']>;
  name: Scalars['String']['output'];
};

export type WarehouseArgs = {
  name: Scalars['String']['input'];
};

export type ActivityLogsCountQueryVariables = Exact<{
  pagination?: InputMaybe<PaginationInput>;
  scope: ActivityLogScopeInput;
  locationId: Scalars['String']['input'];
}>;

export type ActivityLogsCountQuery = {
  __typename?: 'Query';
  activityLogs: {
    __typename?: 'ActivityLogEntries';
    totalCount: number;
    pageInfo: {
      __typename?: 'PageInfo';
      hasNextPage: boolean;
      endCursor?: string | null;
    };
  };
};

export type ActivityLogsQueryVariables = Exact<{
  pagination?: InputMaybe<PaginationInput>;
  scope: ActivityLogScopeInput;
  locationId: Scalars['String']['input'];
}>;

export type ActivityLogsQuery = {
  __typename?: 'Query';
  activityLogs: {
    __typename?: 'ActivityLogEntries';
    totalCount: number;
    nodes: Array<{
      __typename?: 'ActivityLogEntry';
      _id: string;
      event: any;
      timestamp: number;
      location?: {
        __typename?: 'LocationRef';
        _id: string;
        atkomstClientId: string;
        country: string;
        name: string;
        cdsLocation?: Array<{
          __typename?: 'CdsLocationEntry';
          name: string;
          primary: boolean;
        }> | null;
      } | null;
      targetEntity: {
        __typename?: 'ActivityLogEntryTargetEntity';
        type: ActivityLogEntryType;
        ref:
          | { __typename?: 'InvitationRef'; _id: string }
          | {
              __typename?: 'ItemRefWithImage';
              _id: string;
              displayName: string;
              imageUrl: string;
              productName: string;
              type: ItemType;
            }
          | {
              __typename?: 'LocationRef';
              _id: string;
              atkomstClientId: string;
              country: string;
              name: string;
              cdsLocation?: Array<{
                __typename?: 'CdsLocationEntry';
                name: string;
                primary: boolean;
              }> | null;
            }
          | {
              __typename?: 'OrderRef';
              _id: string;
              slug: string;
              orderType: OrderType;
            }
          | { __typename?: 'UserGroupRef'; _id: string; name: string };
      };
      user: {
        __typename?: 'UserRef';
        displayName: string;
        email: string;
        jobTitle?: string | null;
        manager?: string | null;
        networkId?: string | null;
        officeLocation?: string | null;
      };
    }>;
    pageInfo: {
      __typename?: 'PageInfo';
      hasNextPage: boolean;
      endCursor?: string | null;
    };
  };
};

export type CreateImageUploadUrlMutationVariables = Exact<{
  input: CreateImageUploadUrlInput;
}>;

export type CreateImageUploadUrlMutation = {
  __typename?: 'Mutation';
  createImageUploadUrl: {
    __typename?: 'ImageUploadUrl';
    uploadUrl: string;
    publicUrl: string;
  };
};

export type GetAppConfigQueryVariables = Exact<{ [key: string]: never }>;

export type GetAppConfigQuery = {
  __typename?: 'Query';
  appConfig: {
    __typename?: 'AppConfig';
    contactEmail?: string | null;
    maintenanceStatus: {
      __typename?: 'MaintenanceStatus';
      enabled: boolean;
      dismissable?: boolean | null;
      text?: string | null;
      emergency?: boolean | null;
      forceViewerMode?: boolean | null;
    };
  };
};

export type SendMessageMutationVariables = Exact<{
  sendMessageInput: SendMessageInput;
}>;

export type SendMessageMutation = {
  __typename?: 'Mutation';
  sendMessage: boolean;
};

export type InvitationQueryVariables = Exact<{
  invitationId: Scalars['String']['input'];
}>;

export type InvitationQuery = {
  __typename?: 'Query';
  invitation?: {
    __typename?: 'Invitation';
    _id: string;
    _orderId?: string | null;
    email: string;
    name: string;
    expiresAt: number;
    location: {
      __typename?: 'LocationRef';
      _id: string;
      atkomstClientId: string;
      country: string;
      name: string;
      cdsLocation?: Array<{
        __typename?: 'CdsLocationEntry';
        name: string;
        primary: boolean;
      }> | null;
    };
  } | null;
};

export type InvitationsQueryVariables = Exact<{
  locationId: Scalars['String']['input'];
}>;

export type InvitationsQuery = {
  __typename?: 'Query';
  invitations: {
    __typename?: 'Invitations';
    totalCount: number;
    nodes: Array<{
      __typename?: 'Invitation';
      _id: string;
      email: string;
      expiresAt: number;
      metadata_created?: number | null;
      metadata_deleted?: number | null;
      metadata_updated?: number | null;
      name: string;
      location: {
        __typename?: 'LocationRef';
        _id: string;
        atkomstClientId: string;
        country: string;
        name: string;
        cdsLocation?: Array<{
          __typename?: 'CdsLocationEntry';
          name: string;
          primary: boolean;
        }> | null;
      };
      order?: {
        __typename?: 'InvitationOrderRef';
        _id: string;
        slug: string;
        requestedFor: {
          __typename?: 'UserRef';
          displayName: string;
          email: string;
        };
      } | null;
    }>;
    pageInfo: {
      __typename?: 'PageInfo';
      endCursor?: string | null;
      hasNextPage: boolean;
    };
  };
};

export type CreateInvitationMutationVariables = Exact<{
  invitation: CreateInvitationInput;
  locationId: Scalars['String']['input'];
}>;

export type CreateInvitationMutation = {
  __typename?: 'Mutation';
  createInvitation: {
    __typename?: 'MutationResponse';
    _id?: Array<string> | null;
    result: boolean;
  };
};

export type UpdateInvitationOwnershipMutationVariables = Exact<{
  invitationId: Scalars['String']['input'];
  locationId: Scalars['String']['input'];
  user: UserInput;
}>;

export type UpdateInvitationOwnershipMutation = {
  __typename?: 'Mutation';
  updateInvitationOwnership: {
    __typename?: 'MutationResponse';
    _id?: Array<string> | null;
    result: boolean;
  };
};

export type ItemQueryVariables = Exact<{
  itemId: Scalars['String']['input'];
}>;

export type ItemQuery = {
  __typename?: 'Query';
  item?: {
    __typename?: 'Item';
    _id: string;
    category: number;
    categories: Array<string>;
    description: string;
    displayName: string;
    imageUrls: Array<string>;
    productName: string;
    sku: string;
    slug: string;
    type: ItemType;
    combinations: {
      __typename?: 'Combinations';
      color?: CombinationColor | null;
      fit?: string | null;
      size?: string | null;
    };
    documents: Array<{ __typename?: 'Document'; name: string; url: string }>;
    price?: { __typename?: 'Price'; amount: number; currency: string } | null;
    properties: {
      __typename?: 'Properties';
      depth?: number | null;
      height?: number | null;
      material?: string | null;
      weight?: number | null;
      width?: number | null;
    };
  } | null;
};

export type ItemsQueryVariables = Exact<{
  locationId: Scalars['String']['input'];
  pagination?: InputMaybe<PaginationInput>;
}>;

export type ItemsQuery = {
  __typename?: 'Query';
  items: {
    __typename?: 'Items';
    nodes: Array<{
      __typename?: 'Item';
      _id: string;
      category: number;
      categories: Array<string>;
      description: string;
      displayName: string;
      imageUrls: Array<string>;
      productName: string;
      sku: string;
      slug: string;
      type: ItemType;
      location?: {
        __typename?: 'LocationRef';
        _id: string;
        atkomstClientId: string;
        country: string;
        name: string;
      } | null;
      combinations: {
        __typename?: 'Combinations';
        color?: CombinationColor | null;
        fit?: string | null;
        size?: string | null;
      };
      documents: Array<{ __typename?: 'Document'; name: string; url: string }>;
      price?: { __typename?: 'Price'; amount: number; currency: string } | null;
      properties: {
        __typename?: 'Properties';
        depth?: number | null;
        height?: number | null;
        material?: string | null;
        weight?: number | null;
        width?: number | null;
      };
      source: {
        __typename?: 'ItemSource';
        origin: ItemOrigin;
        url?: string | null;
      };
    }>;
  };
};

export type BulkCreateLocalItemsMutationVariables = Exact<{
  items: Array<CreateLocalItemsInput> | CreateLocalItemsInput;
  locationId: Scalars['String']['input'];
}>;

export type BulkCreateLocalItemsMutation = {
  __typename?: 'Mutation';
  bulkCreateLocalItems: {
    __typename?: 'MutationResponse';
    _id?: Array<string> | null;
    result: boolean;
  };
};

export type BulkUpdateLocalItemsMutationVariables = Exact<{
  product: Array<UpdateLocalItemInput> | UpdateLocalItemInput;
  locationId: Scalars['String']['input'];
}>;

export type BulkUpdateLocalItemsMutation = {
  __typename?: 'Mutation';
  bulkUpdateLocalItems: {
    __typename?: 'MutationResponse';
    _id?: Array<string> | null;
    result: boolean;
  };
};

export type BulkRecallItemsMutationVariables = Exact<{
  itemIds: Array<Scalars['String']['input']> | Scalars['String']['input'];
  locationId: Scalars['String']['input'];
}>;

export type BulkRecallItemsMutation = {
  __typename?: 'Mutation';
  bulkRecallItems: {
    __typename?: 'MutationResponse';
    _id?: Array<string> | null;
    result: boolean;
  };
};

export type RecallUserItemsMutationVariables = Exact<{
  locationId: Scalars['String']['input'];
  userEmail: Scalars['String']['input'];
}>;

export type RecallUserItemsMutation = {
  __typename?: 'Mutation';
  recallUserItems: {
    __typename?: 'MutationResponse';
    _id?: Array<string> | null;
    result: boolean;
  };
};

export type BulkDeleteLocalItemsMutationVariables = Exact<{
  itemIds: Array<Scalars['String']['input']> | Scalars['String']['input'];
  locationId: Scalars['String']['input'];
}>;

export type BulkDeleteLocalItemsMutation = {
  __typename?: 'Mutation';
  bulkDeleteLocalItems: {
    __typename?: 'MutationResponse';
    result: boolean;
    _id?: Array<string> | null;
  };
};

export type LocationsQueryVariables = Exact<{
  pagination?: InputMaybe<PaginationInput>;
}>;

export type LocationsQuery = {
  __typename?: 'Query';
  locations: {
    __typename?: 'Locations';
    nodes: Array<{
      __typename?: 'Location';
      _id: string;
      name: string;
      atkomstClientId: string;
      country: string;
      slug: string;
      cdsLocation?: Array<{
        __typename?: 'CdsLocationEntry';
        name: string;
        primary: boolean;
      }> | null;
      settings: {
        __typename?: 'LocationSettings';
        communication: {
          __typename?: 'CommunicationSettings';
          adminInbox?: string | null;
          language: string;
        };
        bookings: {
          __typename?: 'BookingsSettings';
          acceptTermsText?: string | null;
          usersCanSetCollectedState?: boolean | null;
          allowOutOfStockOrders?: boolean | null;
        };
        helpCenter: {
          __typename?: 'HelpCenterSettings';
          contactEmail?: string | null;
        };
      };
    }>;
  };
};

export type LocationQueryVariables = Exact<{
  locationId: Scalars['String']['input'];
}>;

export type LocationQuery = {
  __typename?: 'Query';
  location?: {
    __typename?: 'Location';
    _id: string;
    atkomstClientId: string;
    country: string;
    enabled: boolean;
    mainLanguage: string;
    name: string;
    slug: string;
    stock: Array<{
      __typename?: 'StockItem';
      reserved: number;
      refurbish: number;
      lendOut: number;
      discarded: number;
      item: {
        __typename?: 'ItemRef';
        type: ItemType;
        productName: string;
        displayName: string;
        _id: string;
      };
      availability: Array<{
        __typename?: 'StockItemAvailability';
        threshold: number;
        amount: number;
        _warehouseId: string;
      }>;
    }>;
    cdsLocation?: Array<{
      __typename?: 'CdsLocationEntry';
      name: string;
      primary: boolean;
    }> | null;
    warehouses: Array<{ __typename?: 'Warehouse'; _id: string; name: string }>;
    settings: {
      __typename?: 'LocationSettings';
      communication: {
        __typename?: 'CommunicationSettings';
        adminInbox?: string | null;
        language: string;
      };
      bookings: {
        __typename?: 'BookingsSettings';
        acceptTermsText?: string | null;
        usersCanSetCollectedState?: boolean | null;
        allowOutOfStockOrders?: boolean | null;
      };
      helpCenter: {
        __typename?: 'HelpCenterSettings';
        contactEmail?: string | null;
      };
    };
  } | null;
};

export type SuperadminLocationsQueryVariables = Exact<{
  pagination?: InputMaybe<PaginationInput>;
}>;

export type SuperadminLocationsQuery = {
  __typename?: 'Query';
  superadminLocations: {
    __typename?: 'Locations';
    nodes: Array<{
      __typename?: 'Location';
      _id: string;
      name: string;
      atkomstClientId: string;
      country: string;
      enabled: boolean;
      mainLanguage: string;
      slug: string;
      cdsLocation?: Array<{
        __typename?: 'CdsLocationEntry';
        name: string;
        primary: boolean;
      }> | null;
    }>;
  };
};

export type CreateLocationMutationVariables = Exact<{
  input: CreateLocationInput;
}>;

export type CreateLocationMutation = {
  __typename?: 'Mutation';
  createLocation: {
    __typename?: 'Location';
    _id: string;
    name: string;
    atkomstClientId: string;
    country: string;
    enabled: boolean;
    mainLanguage: string;
    slug: string;
  };
};

export type UpdateLocationMutationVariables = Exact<{
  locationId: Scalars['String']['input'];
  input: UpdateLocationInput;
}>;

export type UpdateLocationMutation = {
  __typename?: 'Mutation';
  updateLocation: {
    __typename?: 'MutationResponse';
    _id?: Array<string> | null;
    result: boolean;
  };
};

export type CreateWarehouseMutationVariables = Exact<{
  locationId: Scalars['String']['input'];
  warehouse: WarehouseArgs;
}>;

export type CreateWarehouseMutation = {
  __typename?: 'Mutation';
  createWarehouse: {
    __typename?: 'MutationResponse';
    _id?: Array<string> | null;
    result: boolean;
  };
};

export type UpdateWarehouseMutationVariables = Exact<{
  locationId: Scalars['String']['input'];
  warehouseId: Scalars['String']['input'];
  warehouse: WarehouseArgs;
}>;

export type UpdateWarehouseMutation = {
  __typename?: 'Mutation';
  updateWarehouse: {
    __typename?: 'MutationResponse';
    _id?: Array<string> | null;
    result: boolean;
  };
};

export type DeleteWarehouseMutationVariables = Exact<{
  locationId: Scalars['String']['input'];
  warehouseId: Scalars['String']['input'];
}>;

export type DeleteWarehouseMutation = {
  __typename?: 'Mutation';
  deleteWarehouse: {
    __typename?: 'MutationResponse';
    _id?: Array<string> | null;
    result: boolean;
  };
};

export type BulkEnableStockItemMutationVariables = Exact<{
  locationId: Scalars['String']['input'];
  itemIds: Array<Scalars['String']['input']> | Scalars['String']['input'];
}>;

export type BulkEnableStockItemMutation = {
  __typename?: 'Mutation';
  bulkEnableStockItem: {
    __typename?: 'MutationResponse';
    _id?: Array<string> | null;
    result: boolean;
  };
};

export type BulkDisableStockItemMutationVariables = Exact<{
  locationId: Scalars['String']['input'];
  itemIds: Array<Scalars['String']['input']> | Scalars['String']['input'];
}>;

export type BulkDisableStockItemMutation = {
  __typename?: 'Mutation';
  bulkDisableStockItem: {
    __typename?: 'MutationResponse';
    _id?: Array<string> | null;
    result: boolean;
  };
};

export type BulkUpdateStockMutationVariables = Exact<{
  input: BulkUpdateStockInput;
}>;

export type BulkUpdateStockMutation = {
  __typename?: 'Mutation';
  bulkUpdateStock: {
    __typename?: 'MutationResponse';
    _id?: Array<string> | null;
    result: boolean;
  };
};

export type BulkRemoveStockItemMutationVariables = Exact<{
  locationId: Scalars['String']['input'];
  warehouseId: Scalars['String']['input'];
  itemIds: Array<Scalars['String']['input']> | Scalars['String']['input'];
}>;

export type BulkRemoveStockItemMutation = {
  __typename?: 'Mutation';
  bulkRemoveStockItem: {
    __typename?: 'MutationResponse';
    _id?: Array<string> | null;
    result: boolean;
  };
};

export type UpdateSettingsMutationVariables = Exact<{
  locationId: Scalars['String']['input'];
  settings: UpdateLocationSettingsInput;
}>;

export type UpdateSettingsMutation = {
  __typename?: 'Mutation';
  updateSettings: {
    __typename?: 'MutationResponse';
    _id?: Array<string> | null;
    result: boolean;
  };
};

export type PrimaryLocationsQueryVariables = Exact<{
  country: Scalars['String']['input'];
}>;

export type PrimaryLocationsQuery = {
  __typename?: 'Query';
  atkomstClients: Array<{
    __typename?: 'AtkomstClient';
    country: string;
    name: string;
    id: string;
  }>;
};

export type SecondaryLocationsQueryVariables = Exact<{ [key: string]: never }>;

export type SecondaryLocationsQuery = {
  __typename?: 'Query';
  cdsLocations: Array<{
    __typename?: 'CdsLocation';
    country: string;
    name: string;
    id: string;
  }>;
};

export type OrdersQueryVariables = Exact<{
  locationId?: InputMaybe<Scalars['String']['input']>;
  scope: OrderScopeInput;
  pagination?: InputMaybe<PaginationInput>;
}>;

export type OrdersQuery = {
  __typename?: 'Query';
  orders: {
    __typename?: 'Orders';
    totalCount: number;
    nodes: Array<{
      __typename?: 'Order';
      _id: string;
      metadata_created?: number | null;
      metadata_updated?: number | null;
      slug: string;
      _invitationId?: string | null;
      status: OrderStatus;
      onHold?: boolean | null;
      type: OrderType;
      requestedFor: {
        __typename?: 'UserRef';
        displayName: string;
        email: string;
        manager?: string | null;
      };
      location: {
        __typename?: 'LocationRef';
        _id: string;
        name: string;
        atkomstClientId: string;
        country: string;
      };
      items: Array<{
        __typename?: 'OrderItem';
        _orderItemId: string;
        metadata_created?: number | null;
        metadata_updated?: number | null;
        lastStatus: ItemStatus;
        statusHistory: Array<{
          __typename?: 'StatusHistory';
          status: ItemStatus;
        }>;
        item: {
          __typename?: 'Item';
          _id: string;
          displayName: string;
          category: number;
          imageUrls: Array<string>;
          sku: string;
          slug: string;
          type: ItemType;
        };
      }>;
      requestedBy: {
        __typename?: 'UserRef';
        displayName: string;
        email: string;
      };
    }>;
  };
};

export type CreateOrderMutationVariables = Exact<{
  locationId: Scalars['String']['input'];
  createOrderInput: CreateOrderInput;
}>;

export type CreateOrderMutation = {
  __typename?: 'Mutation';
  createOrder: {
    __typename?: 'MutationResponse';
    _id?: Array<string> | null;
    result: boolean;
  };
};

export type OrderQueryVariables = Exact<{
  orderId: Scalars['String']['input'];
}>;

export type OrderQuery = {
  __typename?: 'Query';
  order?: {
    __typename?: 'Order';
    _id: string;
    _invitationId?: string | null;
    metadata_created?: number | null;
    metadata_deleted?: number | null;
    metadata_updated?: number | null;
    onHold?: boolean | null;
    slug: string;
    status: OrderStatus;
    type: OrderType;
    comments: Array<{
      __typename?: 'OrderComment';
      _orderItemId?: string | null;
      message: string;
      metadata_created?: number | null;
      user: {
        __typename?: 'UserRef';
        displayName: string;
        email: string;
        jobTitle?: string | null;
        manager?: string | null;
        networkId?: string | null;
        officeLocation?: string | null;
      };
    }>;
    items: Array<{
      __typename?: 'OrderItem';
      _orderItemId: string;
      metadata_created?: number | null;
      metadata_deleted?: number | null;
      metadata_updated?: number | null;
      lastStatus: ItemStatus;
      item: {
        __typename?: 'Item';
        _id: string;
        categories: Array<string>;
        category: number;
        description: string;
        displayName: string;
        imageUrls: Array<string>;
        productName: string;
        sku: string;
        slug: string;
        type: ItemType;
        combinations: {
          __typename?: 'Combinations';
          color?: CombinationColor | null;
          fit?: string | null;
          size?: string | null;
        };
        documents: Array<{
          __typename?: 'Document';
          name: string;
          url: string;
        }>;
        price?: {
          __typename?: 'Price';
          amount: number;
          currency: string;
        } | null;
        properties: {
          __typename?: 'Properties';
          depth?: number | null;
          height?: number | null;
          material?: string | null;
          weight?: number | null;
          width?: number | null;
        };
        source: {
          __typename?: 'ItemSource';
          origin: ItemOrigin;
          url?: string | null;
        };
      };
      statusHistory: Array<{
        __typename?: 'StatusHistory';
        metadata_created?: number | null;
        reason?: string | null;
        returnedToStock?: boolean | null;
        status: ItemStatus;
      }>;
    }>;
    location: {
      __typename?: 'LocationRef';
      _id: string;
      atkomstClientId: string;
      country: string;
      name: string;
      cdsLocation?: Array<{
        __typename?: 'CdsLocationEntry';
        name: string;
        primary: boolean;
      }> | null;
    };
    requestedBy: {
      __typename?: 'UserRef';
      displayName: string;
      email: string;
      jobTitle?: string | null;
      manager?: string | null;
      networkId?: string | null;
      officeLocation?: string | null;
    };
    requestedFor: {
      __typename?: 'UserRef';
      displayName: string;
      email: string;
      jobTitle?: string | null;
      manager?: string | null;
      networkId?: string | null;
      officeLocation?: string | null;
    };
  } | null;
};

export type UpdateItemStatusMutationVariables = Exact<{
  bulkUpdateItemStatusInput:
    | Array<UpdateItemstatusInput>
    | UpdateItemstatusInput;
}>;

export type UpdateItemStatusMutation = {
  __typename?: 'Mutation';
  bulkUpdateItemStatus: {
    __typename?: 'MutationResponse';
    _id?: Array<string> | null;
    result: boolean;
  };
};

export type CommentOrderMutationVariables = Exact<{
  commentOrderInput: CommentOrderInput;
}>;

export type CommentOrderMutation = {
  __typename?: 'Mutation';
  commentOrder: {
    __typename?: 'MutationResponse';
    result: boolean;
    _id?: Array<string> | null;
  };
};

export type BulkUpdateOrderOnHoldMutationVariables = Exact<{
  locationId: Scalars['String']['input'];
  onHold: Scalars['Boolean']['input'];
  orderIds: Array<Scalars['String']['input']> | Scalars['String']['input'];
}>;

export type BulkUpdateOrderOnHoldMutation = {
  __typename?: 'Mutation';
  bulkUpdateOrderOnHold: {
    __typename?: 'MutationResponse';
    _id?: Array<string> | null;
    result: boolean;
  };
};

export type GetCurrentRolesQueryVariables = Exact<{ [key: string]: never }>;

export type GetCurrentRolesQuery = {
  __typename?: 'Query';
  roles: {
    __typename?: 'RolesResult';
    accessToken: string;
    roles: Array<{
      __typename?: 'UserRoleResult';
      id: number;
      clientReference: string;
      name: string;
      service: string;
      description: string;
      permissions: Array<{ __typename?: 'RolePermission'; name: string }>;
    }>;
  };
};

export type UserQueryVariables = Exact<{
  locationId: Scalars['String']['input'];
  email: Scalars['String']['input'];
}>;

export type UserQuery = {
  __typename?: 'Query';
  user?: {
    __typename?: 'User';
    orders: { __typename?: 'OrderCounts'; completed: number; pending: number };
    items: {
      __typename?: 'ItemCounts';
      approved: number;
      cancelled: number;
      collected: number;
      discarded: number;
      pending: number;
      prepared: number;
      recalled: number;
      refurbish: number;
      rejected: number;
      returned: number;
    };
  } | null;
};

export type UsersQueryVariables = Exact<{
  locationId: Scalars['String']['input'];
  pagination?: InputMaybe<PaginationInput>;
}>;

export type UsersQuery = {
  __typename?: 'Query';
  users: {
    __typename?: 'Users';
    totalCount: number;
    nodes: Array<{
      __typename?: 'User';
      displayName: string;
      email: string;
      manager?: string | null;
      orders: {
        __typename?: 'OrderCounts';
        completed: number;
        pending: number;
      };
      items: {
        __typename?: 'ItemCounts';
        approved: number;
        cancelled: number;
        collected: number;
        discarded: number;
        pending: number;
        prepared: number;
        recalled: number;
        refurbish: number;
        rejected: number;
        returned: number;
      };
    }>;
    pageInfo?: {
      __typename?: 'PageInfo';
      endCursor?: string | null;
      hasNextPage: boolean;
    } | null;
  };
  administrators: {
    __typename?: 'Users';
    totalCount: number;
    nodes: Array<{
      __typename?: 'User';
      displayName: string;
      email: string;
      roles?: Array<string> | null;
      orders: {
        __typename?: 'OrderCounts';
        completed: number;
        pending: number;
      };
      items: {
        __typename?: 'ItemCounts';
        approved: number;
        cancelled: number;
        collected: number;
        discarded: number;
        pending: number;
        prepared: number;
        recalled: number;
        refurbish: number;
        rejected: number;
        returned: number;
      };
    }>;
    pageInfo?: {
      __typename?: 'PageInfo';
      endCursor?: string | null;
      hasNextPage: boolean;
    } | null;
  };
  externalUsers: {
    __typename?: 'Users';
    totalCount: number;
    nodes: Array<{
      __typename?: 'User';
      displayName: string;
      email: string;
      roles?: Array<string> | null;
      orders: {
        __typename?: 'OrderCounts';
        completed: number;
        pending: number;
      };
      items: {
        __typename?: 'ItemCounts';
        approved: number;
        cancelled: number;
        collected: number;
        discarded: number;
        pending: number;
        prepared: number;
        recalled: number;
        refurbish: number;
        rejected: number;
        returned: number;
      };
    }>;
    pageInfo?: {
      __typename?: 'PageInfo';
      endCursor?: string | null;
      hasNextPage: boolean;
    } | null;
  };
};

export type InventoryQueryVariables = Exact<{
  locationId: Scalars['String']['input'];
  scope: InventoryScopeInput;
}>;

export type InventoryQuery = {
  __typename?: 'Query';
  inventory: {
    __typename?: 'UserInventory';
    totalCount: number;
    pageInfo?: {
      __typename?: 'PageInfo';
      hasNextPage: boolean;
      endCursor?: string | null;
    } | null;
    nodes: Array<{
      __typename?: 'InventoryEntry';
      _orderItemId: string;
      lastStatus: ItemStatus;
      order: {
        __typename?: 'OrderRef';
        _id: string;
        slug: string;
        type: OrderType;
      };
      item: {
        __typename?: 'Item';
        _id: string;
        displayName: string;
        category: number;
        imageUrls: Array<string>;
        slug: string;
        sku: string;
      };
    }>;
  };
};

export type AddExternalCoworkerMutationVariables = Exact<{
  locationId: Scalars['String']['input'];
  email: Scalars['String']['input'];
}>;

export type AddExternalCoworkerMutation = {
  __typename?: 'Mutation';
  addExternalCoworker: { __typename?: 'MutationResponse'; result: boolean };
};

export type RemoveExternalCoworkerMutationVariables = Exact<{
  locationId: Scalars['String']['input'];
  email: Scalars['String']['input'];
}>;

export type RemoveExternalCoworkerMutation = {
  __typename?: 'Mutation';
  removeExternalCoworker: { __typename?: 'MutationResponse'; result: boolean };
};

export type UpdateUserRolesMutationVariables = Exact<{
  locationId: Scalars['String']['input'];
  email: Scalars['String']['input'];
  roles: UserRolesInput;
}>;

export type UpdateUserRolesMutation = {
  __typename?: 'Mutation';
  updateUserRoles: { __typename?: 'MutationResponse'; result: boolean };
};

export const ActivityLogsCountDocument = `
    query ActivityLogsCount($pagination: PaginationInput, $scope: ActivityLogScopeInput!, $locationId: String!) {
  activityLogs(pagination: $pagination, scope: $scope, locationId: $locationId) {
    totalCount
    pageInfo {
      hasNextPage
      endCursor
    }
  }
}
    `;
export const ActivityLogsDocument = `
    query ActivityLogs($pagination: PaginationInput, $scope: ActivityLogScopeInput!, $locationId: String!) {
  activityLogs(pagination: $pagination, scope: $scope, locationId: $locationId) {
    nodes {
      _id
      location {
        _id
        atkomstClientId
        cdsLocation {
          name
          primary
        }
        country
        name
      }
      targetEntity {
        ref {
          ... on InvitationRef {
            _id
          }
          ... on ItemRefWithImage {
            _id
            displayName
            imageUrl
            productName
            type
          }
          ... on LocationRef {
            _id
            atkomstClientId
            cdsLocation {
              name
              primary
            }
            country
            name
          }
          ... on OrderRef {
            _id
            slug
            orderType: type
          }
          ... on UserGroupRef {
            _id
            name
          }
        }
        type
      }
      user {
        displayName
        email
        jobTitle
        manager
        networkId
        officeLocation
      }
      event
      timestamp
    }
    totalCount
    pageInfo {
      hasNextPage
      endCursor
    }
  }
}
    `;
export const CreateImageUploadUrlDocument = `
    mutation CreateImageUploadUrl($input: CreateImageUploadUrlInput!) {
  createImageUploadUrl(input: $input) {
    uploadUrl
    publicUrl
  }
}
    `;
export const GetAppConfigDocument = `
    query GetAppConfig {
  appConfig {
    maintenanceStatus {
      enabled
      dismissable
      text
      emergency
      forceViewerMode
    }
    contactEmail
  }
}
    `;
export const SendMessageDocument = `
    mutation SendMessage($sendMessageInput: SendMessageInput!) {
  sendMessage(sendMessageInput: $sendMessageInput)
}
    `;
export const InvitationDocument = `
    query Invitation($invitationId: String!) {
  invitation(invitationId: $invitationId) {
    _id
    _orderId
    email
    name
    expiresAt
    location {
      _id
      atkomstClientId
      cdsLocation {
        name
        primary
      }
      country
      name
    }
  }
}
    `;
export const InvitationsDocument = `
    query Invitations($locationId: String!) {
  invitations(locationId: $locationId) {
    nodes {
      _id
      email
      expiresAt
      location {
        _id
        atkomstClientId
        cdsLocation {
          name
          primary
        }
        country
        name
      }
      metadata_created
      metadata_deleted
      metadata_updated
      name
      order {
        _id
        slug
        requestedFor {
          displayName
          email
        }
      }
    }
    pageInfo {
      endCursor
      hasNextPage
    }
    totalCount
  }
}
    `;
export const CreateInvitationDocument = `
    mutation CreateInvitation($invitation: CreateInvitationInput!, $locationId: String!) {
  createInvitation(invitation: $invitation, locationId: $locationId) {
    _id
    result
  }
}
    `;
export const UpdateInvitationOwnershipDocument = `
    mutation UpdateInvitationOwnership($invitationId: String!, $locationId: String!, $user: UserInput!) {
  updateInvitationOwnership(
    invitationId: $invitationId
    locationId: $locationId
    user: $user
  ) {
    _id
    result
  }
}
    `;
export const ItemDocument = `
    query Item($itemId: String!) {
  item(itemId: $itemId) {
    _id
    category
    categories
    combinations {
      color
      fit
      size
    }
    description
    displayName
    documents {
      name
      url
    }
    imageUrls
    price {
      amount
      currency
    }
    productName
    properties {
      depth
      height
      material
      weight
      width
    }
    sku
    slug
    type
  }
}
    `;
export const ItemsDocument = `
    query Items($locationId: String!, $pagination: PaginationInput) {
  items(locationId: $locationId, pagination: $pagination) {
    nodes {
      _id
      category
      categories
      location {
        _id
        atkomstClientId
        country
        name
      }
      combinations {
        color
        fit
        size
      }
      description
      displayName
      documents {
        name
        url
      }
      imageUrls
      price {
        amount
        currency
      }
      productName
      properties {
        depth
        height
        material
        weight
        width
      }
      sku
      slug
      type
      source {
        origin
        url
      }
    }
  }
}
    `;
export const BulkCreateLocalItemsDocument = `
    mutation BulkCreateLocalItems($items: [CreateLocalItemsInput!]!, $locationId: String!) {
  bulkCreateLocalItems(items: $items, locationId: $locationId) {
    _id
    result
  }
}
    `;
export const BulkUpdateLocalItemsDocument = `
    mutation BulkUpdateLocalItems($product: [UpdateLocalItemInput!]!, $locationId: String!) {
  bulkUpdateLocalItems(product: $product, locationId: $locationId) {
    _id
    result
  }
}
    `;
export const BulkRecallItemsDocument = `
    mutation BulkRecallItems($itemIds: [String!]!, $locationId: String!) {
  bulkRecallItems(itemIds: $itemIds, locationId: $locationId) {
    _id
    result
  }
}
    `;
export const RecallUserItemsDocument = `
    mutation RecallUserItems($locationId: String!, $userEmail: String!) {
  recallUserItems(locationId: $locationId, userEmail: $userEmail) {
    _id
    result
  }
}
    `;
export const BulkDeleteLocalItemsDocument = `
    mutation BulkDeleteLocalItems($itemIds: [String!]!, $locationId: String!) {
  bulkDeleteLocalItems(itemIds: $itemIds, locationId: $locationId) {
    result
    _id
  }
}
    `;
export const LocationsDocument = `
    query Locations($pagination: PaginationInput) {
  locations(pagination: $pagination) {
    nodes {
      _id
      name
      atkomstClientId
      cdsLocation {
        name
        primary
      }
      country
      slug
      settings {
        communication {
          adminInbox
          language
        }
        bookings {
          acceptTermsText
          usersCanSetCollectedState
          allowOutOfStockOrders
        }
        helpCenter {
          contactEmail
        }
      }
    }
  }
}
    `;
export const LocationDocument = `
    query Location($locationId: String!) {
  location(locationId: $locationId) {
    _id
    stock {
      reserved
      refurbish
      lendOut
      item {
        type
        productName
        displayName
        _id
      }
      discarded
      availability {
        threshold
        amount
        _warehouseId
      }
    }
    atkomstClientId
    cdsLocation {
      name
      primary
    }
    country
    enabled
    mainLanguage
    name
    slug
    warehouses {
      _id
      name
    }
    settings {
      communication {
        adminInbox
        language
      }
      bookings {
        acceptTermsText
        usersCanSetCollectedState
        allowOutOfStockOrders
      }
      helpCenter {
        contactEmail
      }
    }
  }
}
    `;
export const SuperadminLocationsDocument = `
    query SuperadminLocations($pagination: PaginationInput) {
  superadminLocations(pagination: $pagination) {
    nodes {
      _id
      name
      atkomstClientId
      cdsLocation {
        name
        primary
      }
      country
      enabled
      mainLanguage
      slug
    }
  }
}
    `;
export const CreateLocationDocument = `
    mutation CreateLocation($input: CreateLocationInput!) {
  createLocation(input: $input) {
    _id
    name
    atkomstClientId
    country
    enabled
    mainLanguage
    slug
  }
}
    `;
export const UpdateLocationDocument = `
    mutation UpdateLocation($locationId: String!, $input: UpdateLocationInput!) {
  updateLocation(locationId: $locationId, input: $input) {
    _id
    result
  }
}
    `;
export const CreateWarehouseDocument = `
    mutation CreateWarehouse($locationId: String!, $warehouse: WarehouseArgs!) {
  createWarehouse(locationId: $locationId, warehouse: $warehouse) {
    _id
    result
  }
}
    `;
export const UpdateWarehouseDocument = `
    mutation UpdateWarehouse($locationId: String!, $warehouseId: String!, $warehouse: WarehouseArgs!) {
  updateWarehouse(
    locationId: $locationId
    warehouseId: $warehouseId
    warehouse: $warehouse
  ) {
    _id
    result
  }
}
    `;
export const DeleteWarehouseDocument = `
    mutation DeleteWarehouse($locationId: String!, $warehouseId: String!) {
  deleteWarehouse(locationId: $locationId, warehouseId: $warehouseId) {
    _id
    result
  }
}
    `;
export const BulkEnableStockItemDocument = `
    mutation BulkEnableStockItem($locationId: String!, $itemIds: [String!]!) {
  bulkEnableStockItem(locationId: $locationId, itemIds: $itemIds) {
    _id
    result
  }
}
    `;
export const BulkDisableStockItemDocument = `
    mutation BulkDisableStockItem($locationId: String!, $itemIds: [String!]!) {
  bulkDisableStockItem(locationId: $locationId, itemIds: $itemIds) {
    _id
    result
  }
}
    `;
export const BulkUpdateStockDocument = `
    mutation BulkUpdateStock($input: BulkUpdateStockInput!) {
  bulkUpdateStock(input: $input) {
    _id
    result
  }
}
    `;
export const BulkRemoveStockItemDocument = `
    mutation BulkRemoveStockItem($locationId: String!, $warehouseId: String!, $itemIds: [String!]!) {
  bulkRemoveStockItem(
    locationId: $locationId
    warehouseId: $warehouseId
    itemIds: $itemIds
  ) {
    _id
    result
  }
}
    `;
export const UpdateSettingsDocument = `
    mutation UpdateSettings($locationId: String!, $settings: UpdateLocationSettingsInput!) {
  updateSettings(locationId: $locationId, settings: $settings) {
    _id
    result
  }
}
    `;
export const PrimaryLocationsDocument = `
    query PrimaryLocations($country: String!) {
  atkomstClients(country: $country) {
    country
    name
    id
  }
}
    `;
export const SecondaryLocationsDocument = `
    query SecondaryLocations {
  cdsLocations {
    country
    name
    id
  }
}
    `;
export const OrdersDocument = `
    query Orders($locationId: String, $scope: OrderScopeInput!, $pagination: PaginationInput) {
  orders(locationId: $locationId, scope: $scope, pagination: $pagination) {
    totalCount
    nodes {
      _id
      metadata_created
      metadata_updated
      slug
      _invitationId
      requestedFor {
        displayName
        email
      }
      status
      onHold
      location {
        _id
        name
        atkomstClientId
        country
      }
      items {
        _orderItemId
        metadata_created
        metadata_updated
        lastStatus
        statusHistory {
          status
        }
        item {
          _id
          displayName
          category
          imageUrls
          sku
          slug
          type
        }
      }
      requestedFor {
        displayName
        email
        manager
      }
      requestedBy {
        displayName
        email
      }
      type
    }
  }
}
    `;
export const CreateOrderDocument = `
    mutation createOrder($locationId: String!, $createOrderInput: CreateOrderInput!) {
  createOrder(locationId: $locationId, createOrderInput: $createOrderInput) {
    _id
    result
  }
}
    `;
export const OrderDocument = `
    query Order($orderId: String!) {
  order(orderId: $orderId) {
    _id
    _invitationId
    comments {
      _orderItemId
      message
      metadata_created
      user {
        displayName
        email
        jobTitle
        manager
        networkId
        officeLocation
      }
    }
    items {
      _orderItemId
      metadata_created
      metadata_deleted
      metadata_updated
      item {
        _id
        categories
        category
        combinations {
          color
          fit
          size
        }
        description
        displayName
        documents {
          name
          url
        }
        imageUrls
        price {
          amount
          currency
        }
        productName
        properties {
          depth
          height
          material
          weight
          width
        }
        sku
        slug
        source {
          origin
          url
        }
        type
      }
      lastStatus
      statusHistory {
        metadata_created
        reason
        returnedToStock
        status
      }
    }
    location {
      _id
      atkomstClientId
      cdsLocation {
        name
        primary
      }
      country
      name
    }
    metadata_created
    metadata_deleted
    metadata_updated
    onHold
    requestedBy {
      displayName
      email
      jobTitle
      manager
      networkId
      officeLocation
    }
    requestedFor {
      displayName
      email
      jobTitle
      manager
      networkId
      officeLocation
    }
    slug
    status
    type
  }
}
    `;
export const UpdateItemStatusDocument = `
    mutation UpdateItemStatus($bulkUpdateItemStatusInput: [UpdateItemstatusInput!]!) {
  bulkUpdateItemStatus(bulkUpdateItemStatusInput: $bulkUpdateItemStatusInput) {
    _id
    result
  }
}
    `;
export const CommentOrderDocument = `
    mutation CommentOrder($commentOrderInput: CommentOrderInput!) {
  commentOrder(commentOrderInput: $commentOrderInput) {
    result
    _id
  }
}
    `;
export const BulkUpdateOrderOnHoldDocument = `
    mutation BulkUpdateOrderOnHold($locationId: String!, $onHold: Boolean!, $orderIds: [String!]!) {
  bulkUpdateOrderOnHold(
    locationId: $locationId
    onHold: $onHold
    orderIds: $orderIds
  ) {
    _id
    result
  }
}
    `;
export const GetCurrentRolesDocument = `
    query GetCurrentRoles {
  roles {
    accessToken
    roles {
      id
      clientReference
      name
      service
      description
      permissions {
        name
      }
    }
  }
}
    `;
export const UserDocument = `
    query User($locationId: String!, $email: String!) {
  user(locationId: $locationId, email: $email) {
    orders {
      completed
      pending
    }
    items {
      approved
      cancelled
      collected
      discarded
      pending
      prepared
      recalled
      refurbish
      rejected
      returned
    }
  }
}
    `;
export const UsersDocument = `
    query Users($locationId: String!, $pagination: PaginationInput) {
  users(locationId: $locationId, pagination: $pagination) {
    nodes {
      displayName
      email
      manager
      orders {
        completed
        pending
      }
      items {
        approved
        cancelled
        collected
        discarded
        pending
        prepared
        recalled
        refurbish
        rejected
        returned
      }
    }
    totalCount
    pageInfo {
      endCursor
      hasNextPage
    }
  }
  administrators(locationId: $locationId, pagination: $pagination) {
    nodes {
      displayName
      email
      roles
      orders {
        completed
        pending
      }
      items {
        approved
        cancelled
        collected
        discarded
        pending
        prepared
        recalled
        refurbish
        rejected
        returned
      }
    }
    totalCount
    pageInfo {
      endCursor
      hasNextPage
    }
  }
  externalUsers(locationId: $locationId, pagination: $pagination) {
    nodes {
      displayName
      email
      roles
      orders {
        completed
        pending
      }
      items {
        approved
        cancelled
        collected
        discarded
        pending
        prepared
        recalled
        refurbish
        rejected
        returned
      }
    }
    totalCount
    pageInfo {
      endCursor
      hasNextPage
    }
  }
}
    `;
export const InventoryDocument = `
    query Inventory($locationId: String!, $scope: InventoryScopeInput!) {
  inventory(locationId: $locationId, scope: $scope) {
    totalCount
    pageInfo {
      hasNextPage
      endCursor
    }
    nodes {
      _orderItemId
      lastStatus
      order {
        _id
        slug
        type
      }
      item {
        _id
        displayName
        category
        imageUrls
        slug
        sku
      }
    }
  }
}
    `;
export const AddExternalCoworkerDocument = `
    mutation AddExternalCoworker($locationId: String!, $email: String!) {
  addExternalCoworker(locationId: $locationId, email: $email) {
    result
  }
}
    `;
export const RemoveExternalCoworkerDocument = `
    mutation RemoveExternalCoworker($locationId: String!, $email: String!) {
  removeExternalCoworker(locationId: $locationId, email: $email) {
    result
  }
}
    `;
export const UpdateUserRolesDocument = `
    mutation UpdateUserRoles($locationId: String!, $email: String!, $roles: UserRolesInput!) {
  updateUserRoles(locationId: $locationId, email: $email, roles: $roles) {
    result
  }
}
    `;

const injectedRtkApi = backDashboardApi.injectEndpoints({
  overrideExisting: true,
  endpoints: (build) => ({
    ActivityLogsCount: build.query<
      ActivityLogsCountQuery,
      ActivityLogsCountQueryVariables
    >({
      query: (variables) => ({
        document: ActivityLogsCountDocument,
        variables,
      }),
    }),
    ActivityLogs: build.query<ActivityLogsQuery, ActivityLogsQueryVariables>({
      query: (variables) => ({ document: ActivityLogsDocument, variables }),
    }),
    CreateImageUploadUrl: build.mutation<
      CreateImageUploadUrlMutation,
      CreateImageUploadUrlMutationVariables
    >({
      query: (variables) => ({
        document: CreateImageUploadUrlDocument,
        variables,
      }),
    }),
    GetAppConfig: build.query<
      GetAppConfigQuery,
      GetAppConfigQueryVariables | void
    >({
      query: (variables) => ({ document: GetAppConfigDocument, variables }),
    }),
    SendMessage: build.mutation<
      SendMessageMutation,
      SendMessageMutationVariables
    >({
      query: (variables) => ({ document: SendMessageDocument, variables }),
    }),
    Invitation: build.query<InvitationQuery, InvitationQueryVariables>({
      query: (variables) => ({ document: InvitationDocument, variables }),
    }),
    Invitations: build.query<InvitationsQuery, InvitationsQueryVariables>({
      query: (variables) => ({ document: InvitationsDocument, variables }),
    }),
    CreateInvitation: build.mutation<
      CreateInvitationMutation,
      CreateInvitationMutationVariables
    >({
      query: (variables) => ({ document: CreateInvitationDocument, variables }),
    }),
    UpdateInvitationOwnership: build.mutation<
      UpdateInvitationOwnershipMutation,
      UpdateInvitationOwnershipMutationVariables
    >({
      query: (variables) => ({
        document: UpdateInvitationOwnershipDocument,
        variables,
      }),
    }),
    Item: build.query<ItemQuery, ItemQueryVariables>({
      query: (variables) => ({ document: ItemDocument, variables }),
    }),
    Items: build.query<ItemsQuery, ItemsQueryVariables>({
      query: (variables) => ({ document: ItemsDocument, variables }),
    }),
    BulkCreateLocalItems: build.mutation<
      BulkCreateLocalItemsMutation,
      BulkCreateLocalItemsMutationVariables
    >({
      query: (variables) => ({
        document: BulkCreateLocalItemsDocument,
        variables,
      }),
    }),
    BulkUpdateLocalItems: build.mutation<
      BulkUpdateLocalItemsMutation,
      BulkUpdateLocalItemsMutationVariables
    >({
      query: (variables) => ({
        document: BulkUpdateLocalItemsDocument,
        variables,
      }),
    }),
    BulkRecallItems: build.mutation<
      BulkRecallItemsMutation,
      BulkRecallItemsMutationVariables
    >({
      query: (variables) => ({ document: BulkRecallItemsDocument, variables }),
    }),
    RecallUserItems: build.mutation<
      RecallUserItemsMutation,
      RecallUserItemsMutationVariables
    >({
      query: (variables) => ({ document: RecallUserItemsDocument, variables }),
    }),
    BulkDeleteLocalItems: build.mutation<
      BulkDeleteLocalItemsMutation,
      BulkDeleteLocalItemsMutationVariables
    >({
      query: (variables) => ({
        document: BulkDeleteLocalItemsDocument,
        variables,
      }),
    }),
    Locations: build.query<LocationsQuery, LocationsQueryVariables | void>({
      query: (variables) => ({ document: LocationsDocument, variables }),
    }),
    Location: build.query<LocationQuery, LocationQueryVariables>({
      query: (variables) => ({ document: LocationDocument, variables }),
    }),
    SuperadminLocations: build.query<
      SuperadminLocationsQuery,
      SuperadminLocationsQueryVariables | void
    >({
      query: (variables) => ({
        document: SuperadminLocationsDocument,
        variables,
      }),
    }),
    CreateLocation: build.mutation<
      CreateLocationMutation,
      CreateLocationMutationVariables
    >({
      query: (variables) => ({ document: CreateLocationDocument, variables }),
    }),
    UpdateLocation: build.mutation<
      UpdateLocationMutation,
      UpdateLocationMutationVariables
    >({
      query: (variables) => ({ document: UpdateLocationDocument, variables }),
    }),
    CreateWarehouse: build.mutation<
      CreateWarehouseMutation,
      CreateWarehouseMutationVariables
    >({
      query: (variables) => ({ document: CreateWarehouseDocument, variables }),
    }),
    UpdateWarehouse: build.mutation<
      UpdateWarehouseMutation,
      UpdateWarehouseMutationVariables
    >({
      query: (variables) => ({ document: UpdateWarehouseDocument, variables }),
    }),
    DeleteWarehouse: build.mutation<
      DeleteWarehouseMutation,
      DeleteWarehouseMutationVariables
    >({
      query: (variables) => ({ document: DeleteWarehouseDocument, variables }),
    }),
    BulkEnableStockItem: build.mutation<
      BulkEnableStockItemMutation,
      BulkEnableStockItemMutationVariables
    >({
      query: (variables) => ({
        document: BulkEnableStockItemDocument,
        variables,
      }),
    }),
    BulkDisableStockItem: build.mutation<
      BulkDisableStockItemMutation,
      BulkDisableStockItemMutationVariables
    >({
      query: (variables) => ({
        document: BulkDisableStockItemDocument,
        variables,
      }),
    }),
    BulkUpdateStock: build.mutation<
      BulkUpdateStockMutation,
      BulkUpdateStockMutationVariables
    >({
      query: (variables) => ({ document: BulkUpdateStockDocument, variables }),
    }),
    BulkRemoveStockItem: build.mutation<
      BulkRemoveStockItemMutation,
      BulkRemoveStockItemMutationVariables
    >({
      query: (variables) => ({
        document: BulkRemoveStockItemDocument,
        variables,
      }),
    }),
    UpdateSettings: build.mutation<
      UpdateSettingsMutation,
      UpdateSettingsMutationVariables
    >({
      query: (variables) => ({ document: UpdateSettingsDocument, variables }),
    }),
    PrimaryLocations: build.query<
      PrimaryLocationsQuery,
      PrimaryLocationsQueryVariables
    >({
      query: (variables) => ({ document: PrimaryLocationsDocument, variables }),
    }),
    SecondaryLocations: build.query<
      SecondaryLocationsQuery,
      SecondaryLocationsQueryVariables | void
    >({
      query: (variables) => ({
        document: SecondaryLocationsDocument,
        variables,
      }),
    }),
    Orders: build.query<OrdersQuery, OrdersQueryVariables>({
      query: (variables) => ({ document: OrdersDocument, variables }),
    }),
    createOrder: build.mutation<
      CreateOrderMutation,
      CreateOrderMutationVariables
    >({
      query: (variables) => ({ document: CreateOrderDocument, variables }),
    }),
    Order: build.query<OrderQuery, OrderQueryVariables>({
      query: (variables) => ({ document: OrderDocument, variables }),
    }),
    UpdateItemStatus: build.mutation<
      UpdateItemStatusMutation,
      UpdateItemStatusMutationVariables
    >({
      query: (variables) => ({ document: UpdateItemStatusDocument, variables }),
    }),
    CommentOrder: build.mutation<
      CommentOrderMutation,
      CommentOrderMutationVariables
    >({
      query: (variables) => ({ document: CommentOrderDocument, variables }),
    }),
    BulkUpdateOrderOnHold: build.mutation<
      BulkUpdateOrderOnHoldMutation,
      BulkUpdateOrderOnHoldMutationVariables
    >({
      query: (variables) => ({
        document: BulkUpdateOrderOnHoldDocument,
        variables,
      }),
    }),
    GetCurrentRoles: build.query<
      GetCurrentRolesQuery,
      GetCurrentRolesQueryVariables | void
    >({
      query: (variables) => ({ document: GetCurrentRolesDocument, variables }),
    }),
    User: build.query<UserQuery, UserQueryVariables>({
      query: (variables) => ({ document: UserDocument, variables }),
    }),
    Users: build.query<UsersQuery, UsersQueryVariables>({
      query: (variables) => ({ document: UsersDocument, variables }),
    }),
    Inventory: build.query<InventoryQuery, InventoryQueryVariables>({
      query: (variables) => ({ document: InventoryDocument, variables }),
    }),
    AddExternalCoworker: build.mutation<
      AddExternalCoworkerMutation,
      AddExternalCoworkerMutationVariables
    >({
      query: (variables) => ({
        document: AddExternalCoworkerDocument,
        variables,
      }),
    }),
    RemoveExternalCoworker: build.mutation<
      RemoveExternalCoworkerMutation,
      RemoveExternalCoworkerMutationVariables
    >({
      query: (variables) => ({
        document: RemoveExternalCoworkerDocument,
        variables,
      }),
    }),
    UpdateUserRoles: build.mutation<
      UpdateUserRolesMutation,
      UpdateUserRolesMutationVariables
    >({
      query: (variables) => ({ document: UpdateUserRolesDocument, variables }),
    }),
  }),
});

export { injectedRtkApi as api };
export const {
  useActivityLogsCountQuery,
  useLazyActivityLogsCountQuery,
  useActivityLogsQuery,
  useLazyActivityLogsQuery,
  useCreateImageUploadUrlMutation,
  useGetAppConfigQuery,
  useLazyGetAppConfigQuery,
  useSendMessageMutation,
  useInvitationQuery,
  useLazyInvitationQuery,
  useInvitationsQuery,
  useLazyInvitationsQuery,
  useCreateInvitationMutation,
  useUpdateInvitationOwnershipMutation,
  useItemQuery,
  useLazyItemQuery,
  useItemsQuery,
  useLazyItemsQuery,
  useBulkCreateLocalItemsMutation,
  useBulkUpdateLocalItemsMutation,
  useBulkRecallItemsMutation,
  useRecallUserItemsMutation,
  useBulkDeleteLocalItemsMutation,
  useLocationsQuery,
  useLazyLocationsQuery,
  useLocationQuery,
  useLazyLocationQuery,
  useSuperadminLocationsQuery,
  useLazySuperadminLocationsQuery,
  useCreateLocationMutation,
  useUpdateLocationMutation,
  useCreateWarehouseMutation,
  useUpdateWarehouseMutation,
  useDeleteWarehouseMutation,
  useBulkEnableStockItemMutation,
  useBulkDisableStockItemMutation,
  useBulkUpdateStockMutation,
  useBulkRemoveStockItemMutation,
  useUpdateSettingsMutation,
  usePrimaryLocationsQuery,
  useLazyPrimaryLocationsQuery,
  useSecondaryLocationsQuery,
  useLazySecondaryLocationsQuery,
  useOrdersQuery,
  useLazyOrdersQuery,
  useCreateOrderMutation,
  useOrderQuery,
  useLazyOrderQuery,
  useUpdateItemStatusMutation,
  useCommentOrderMutation,
  useBulkUpdateOrderOnHoldMutation,
  useGetCurrentRolesQuery,
  useLazyGetCurrentRolesQuery,
  useUserQuery,
  useLazyUserQuery,
  useUsersQuery,
  useLazyUsersQuery,
  useInventoryQuery,
  useLazyInventoryQuery,
  useAddExternalCoworkerMutation,
  useRemoveExternalCoworkerMutation,
  useUpdateUserRolesMutation,
} = injectedRtkApi;
